var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.154-240v-40h290.154q62.23 0 106.038-42.692 43.808-42.693 43.808-104.231t-43.808-103.846q-43.808-42.308-106.038-42.308H276.616l118.615 118.615-28.308 28.308L200-593.077 366.923-760l28.308 28.308-118.615 118.615h309.692q78.538 0 134.192 54.154 55.654 54.154 55.654 132T720.5-294.538Q664.846-240 586.308-240H296.154Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.d84638786d1e9cd594c6d4781fbd4ef8.svg";
export { ForwardRef as ReactComponent };